import { many, attr} from 'redux-orm';
import Model from '../base-model';
import courseReducers from './course.reducer';
import { courseActions } from './course.action';

/**
 * Course
 * @typedef {Object} Course
 * @property {string} id
 * @property {string} title
 * @property {string} description
 * @property {string} secondDescription
 * @property {string} image
 * @property {string} video
 * @property {boolean} isActive
 * @property {Date} startDate
 * @property {Date} endDate
 * @property {number} duration
 * @property {string} summary
 * @property {number} term
 * @property {Teacher[]} teachers
 * @property {Chapter[]} chapters
 * @property {number} participationRate
 * @property {number} lockedUnitsCount
 * @property {number} seenUnitsCount
 * @property {number} totalUnitsCount
 * @property {ScoresFactors} scoresFactors
 * @property {number} totalScore
 * @property {Date} reportFinalScoreDate
 */

export class Course extends Model {

    static reducer(action, Self, session) {
        switch (action.type) {
        case courseActions.save:
            courseReducers.save(session, action.course);
            break;
        case courseActions.remove:
            courseReducers.remove(session, action.id);
            break;
        case courseActions.addChapter:
            courseReducers.addChapter(session, action.chapter, action.courseId);
            break;
        case courseActions.removeChapter:
            courseReducers.removeChapter(session, action.chapterId, action.courseId);
            break;
        case courseActions.updateProgress:
            courseReducers.updateProgress(session, action.courseId, action.lockedUnitsCount, action.seenUnitsCount, action.totalUnitsCount);
            break;
        case courseActions.updateParticipationRate:
            courseReducers.updateParticipationRate(session, action.courseId, action.participationRate);
            break;
        case courseActions.updateFinalScores:
            courseReducers.updateFinalScores(session, action.id, action.date, action.score);
            break;
        case courseActions.addFinalScoresFactor:
            courseReducers.addFinalScoresFactor(session, action.courseId, action.key, action.coefficient, action.totalScore, action.score);
            break;
        case courseActions.removeFinalScoresFactor:
            courseReducers.removeFinalScoresFactor(session, action.courseId, action.key);
            break;
        case courseActions.cleanAllScoresFactor:
            courseReducers.cleanAllScoresFactor(session, action.courseId)
            break;
        case courseActions.setPeriods:
            courseReducers.setPeriods(session, action.courseId, action.items)
            break;
        default:
            return undefined;
        }
    }

    toString() {
        return `Course: ${this.title}`
    }
}

Course.modelName = 'Course';

Course.fields = {
    id: attr(),
    title: attr(),
    description: attr(),
    secondDescription: attr(),
    image: attr(),
    video: attr(),
    isActive: attr(),
    startDate: attr(),
    endDate: attr(),
    duration: attr(),
    summary: attr(),
    term: attr(),
    teachers: many('Teacher', 'courses'),
    chapters: many('Chapter', 'courses'),
    periods: many('Period', 'coursers'),
    participationRate: attr(),
    lockedUnitsCount: attr(),
    seenUnitsCount: attr(),
    totalUnitsCount: attr(),
    scoresFactors: many('ScoresFactors', 'course'),
    totalScore: attr(),
    reportFinalScoreDate: attr(),
    fullAccess: attr(),
}

export class ScoresFactors extends Model {

    toString() {
        return `score factor: ${this.key}`
    }
}

ScoresFactors.modelName = 'ScoresFactors';

ScoresFactors.fields = {
    key: attr(),
    coefficient: attr(),
    totalScore: attr(),
    score: attr(),
}